import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { DropzoneAreaBase } from "material-ui-dropzone";
import AddBoxIcon from "@material-ui/icons/AddBox";
import { Formik } from "formik";
import * as YUP from "yup";
import { v4 as uuidv4 } from "uuid";
import DeleteIcon from "@material-ui/icons/Delete";
import { WorkerService } from "src/services/";

const Experience = (props) => {
  const [files, setFiles] = useState([]);  
  const [rows, setRows] = useState(props.values.workExperienceList);
 

  const initialValues = {
    id: uuidv4(),
    firmName: "",
    beginDate: "",
    endDate: "",
    workDefinition: "",
  };
  const validationSchema = YUP.object({});

  const onSubmit = (values, { resetForm }) => { 
    var xx = rows;
    xx.push({ ...values });
    setRows(xx);
    var yy = [];
    rows.map((row) => yy.push({ ...row, id: 0 }));
    props.setFieldValue("workExperienceList", yy);
    resetForm();
    setFiles([]);
  };

  const onDelete = (id) => {
    const newRows = rows.filter((xx) => xx.id !== id);
    props.setFieldValue("workExperienceList", newRows);
    setRows(newRows);
  };
  const handleAdd = async (newFiles) => {
    try {
      setFiles(newFiles);
      const response = await WorkerService.UPLOAD_FILE(newFiles[0].file);
      const { status, statusText } = response;
      if (status === 200) {
        const { success, message } = await response.data;
        if (success) {
          props.setFieldValue("baseFields.resumePath", message);
        } else {
          console.error(message);
        }
      } else {
        console.error(statusText);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = (deleted) => {
    setFiles(files?.filter((f) => f !== deleted));
  };

  return (
    <Card>
      <CardHeader title={"Experience"} />
      <Divider />
      <CardContent>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue,
          }) => (
            <>
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="Firm Name"
                    name="firmName"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.firmName}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="Work Definition"
                    name="workDefinition"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.workDefinition}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label="Begindate"
                    name="beginDate"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.beginDate}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label="Enddate"
                    name="endDate"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.endDate}
                  />
                </Grid>

                <Grid item md={12} xs={12}>
                  <Box display="flex" justifyContent="center">
                    <Button
                      variant="outlined"
                      color="secondary"
                      startIcon={<AddBoxIcon />}
                      onClick={handleSubmit}
                    >
                      Add
                    </Button>
                  </Box>
                </Grid>
                <Grid item md={12} xs={12}>
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>firmName</TableCell>
                          <TableCell>workDefinition</TableCell>
                          <TableCell>beginDate</TableCell>
                          <TableCell>endDate</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows?.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>{row.firmName}</TableCell>
                            <TableCell>{row.workDefinition}</TableCell>
                            <TableCell>{row.beginDate}</TableCell>
                            <TableCell>{row.endDate}</TableCell>
                            <TableCell> 
                              <IconButton
                                aria-label="delete"
                                onClick={() => onDelete(row.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>

                <Grid item md={12} xs={12}>
                  <Box p={2} m={2}>
                    <Card>
                      <CardHeader title={"CV"} />
                      <CardContent>
                        {/* <DropzoneArea
                          ref ={dropZone}
                          dropzoneClass={classes.dropzone}
                          dropzoneParagraphClass={classes.dropzone}
                          showPreviewsInDropzone={true}
                          dropzoneText={
                            "Drag and drop an CV image here or click"
                          }
                          filesLimit={1}

                          showFileNames
                          name="resumePath"
                          onChange={(newfiles) => {
                            console.log(newfiles[0]);
                           // setFiles(newfiles[0]);
                            // if (files && files.length > 0) {
                            //   WorkerService.UPLOAD_FILE(files[0], files[0].name)
                            //     .then((response) => {
                            //       const { message } = response.data;
                            //       props.setFieldValue(
                            //         "baseFields.resumePath",
                            //         message
                            //       );
                            //     })
                            //     .catch((err) => {
                            //       console.log("file-err", err);
                            //     });
                            // }
                          }}
                          onDelete={(files) => {
                            props.setFieldValue(
                              "baseFields.resumePath",
                              undefined
                            );
                          }}
                        /> */}
                        <DropzoneAreaBase
                          fileObjects={files}
                          filesLimit={1}
                          onAdd={handleAdd}
                          onDelete={handleDelete}
                        />
                      </CardContent>
                    </Card>
                  </Box>
                </Grid>
              </Grid>

              <pre>{JSON.stringify(values, null, 2)}</pre>
              <pre>{JSON.stringify(props.values, null, 2)}</pre>
            </>
          )}
        </Formik>
      </CardContent>
      <Divider />
    </Card>
  );
};

export default Experience;
